export default {
  entityName: "City",
  apiEndpoint: "/master/cities",
  permissions: {
    view: "master:view",
    edit: "master:edit",
  },
  columns: [
    { key: "name", label: "City Name", sortable: true },
    { key: "code", label: "City Code", sortable: true, class: () => "font-mono font-bold" },
    { key: "postCode", label: "Post Code / Pincode", sortable: true, class: () => "font-mono" },
    { key: "stateId.name", label: "State Name", sortable: true },
    { key: "countryId.name", label: "Country Name", sortable: true },
  ],
  fields: [
    { name: "name", label: "City Name", type: "text", required: true, placeholder: "e.g. Mumbai" },
    { name: "code", label: "City Code", type: "text", required: true, uppercase: true, placeholder: "e.g. MUM" },
    { name: "postCode", label: "Post Code / Pincode", type: "text", required: true, placeholder: "e.g. 400001" },
    { name: "stateId", label: "State", type: "select", required: false, lookupEndpoint: "/master/states", placeholder: "Select State (Optional)" },
    { name: "countryId", label: "Country", type: "select", required: false, lookupEndpoint: "/master/countries", placeholder: "Select Country (Optional)" },
    
    // Advanced options
    { name: "effectiveFrom", label: "Effective From", type: "date", advanced: true },
    { name: "effectiveTo", label: "Effective To", type: "date", advanced: true },
  ],
  filters: [],
  workflow: {
    type: "city_approval",
    enabled: true,
  },
};
